module.exports = __webpack_public_path__ + "static/media/boat-sail-schooner-svgrepo-com.38ea253e.svg";